import { createContext, useContext, useState, useEffect } from "react";
import { AuthContext } from "./authContext";
import useRole from "./useRole.js";
import { fetchEmployeebyEmail, fetchEmployees, fetchDest, fetchopentasks } from "../api/customerapi";

const AppDataContext = createContext();

export const AppDataProvider = ({ children }) => {
  // const [appData, setAppData] = useState(null);
  // const { data, loading } = useRole(); // custom fetch hook
  const {User} = useContext(AuthContext)
 //const { User } = useAuthContext();
  const [appData, setAppData] = useState(null);
  const [loading, setLoading] = useState(true);
  // Load from localStorage on startup
  useEffect(() => {
    const storedData = localStorage.getItem("appData");
    if (storedData) {
      setAppData(JSON.parse(storedData));
      setLoading(false)
    }
  }, []);

  // When no localStorage data but fresh data becomes available
  useEffect(() => {
    const fetchAllData = async () => {
      if (!User?.email || appData) return;

      try {
        console.log("Fetching fresh data from server...");

        const [empRes, destRes, userRes] = await Promise.all([
          fetchEmployees(),
          fetchDest(),
          fetchEmployeebyEmail(User.email),
          //fetchopentasks()
        ]);

        const destData = destRes.data.filter((d) => "order" in d);
        const dataToStore = {
          employeelist: empRes.data,
          destinationlist: destData[0]?.dest || [],
          cuser: userRes.data.proxy_name,
          role: userRes.data.role,
          //tasklist:taskRes.data
        };

        localStorage.setItem("appData", JSON.stringify(dataToStore));
        setAppData(dataToStore);
      } catch (err) {
        console.error("Error fetching initial app data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [User, appData]);

  // Logout
//   const logout = () => {
//     setAppData(null);
//     localStorage.removeItem("appData");
//   };

  return (
    <AppDataContext.Provider value={{ appData, setAppData, loading }}>
      {children}
    </AppDataContext.Provider>
  );
};

export const useAppData = () => useContext(AppDataContext);